import React from "react";
import { connect } from "react-redux";
import {
    addPaperToUnassigned,
    updateSession,
    updateCalendarSession,
} from "../redux/actions";
import { API_URL } from "../constants";
import { Keyword } from "./Keyword";

class Paper extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleRemovePaperClick = this.handleRemovePaperClick.bind(this);
        this.handleLiftUpClick = this.handleLiftUpClick.bind(this);
        this.handleLiftDownClick = this.handleLiftDownClick.bind(this);
        this.handleDragStart = this.handleDragStart.bind(this);
    }

    getTimezoneBadge = (tz) => {
        if (tz === "1") {
            return <div className={"label label-warning"}>Europe</div>;
        }
        if (tz === "2") {
            return <div className={"label label-danger"}>Asia</div>;
        }
        if (tz === "3") {
            return <div className={"label label-success"}>America</div>;
        }
        return <div className={"label label-default"}>no timezone</div>;
    };
    getDurationBadge = (duration) => {
        if (duration === 6) {
            return <div className={"label label-warning"}>{duration} mins</div>;
        }
        if (duration === 12) {
            return <div className={"label label-danger"}>{duration} mins</div>;
        }
        return <div className={"label label-default"}>{duration} mins</div>;
    };

    handleRemovePaperClick() {
        const { paper } = this.props;
        fetch(API_URL + "/paper-sessions/papers/" + paper.id, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + this.props.user.api_token,
            },
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText); // Will go to .catch
                return response.json();
            })
            .then((data) => {
                const { session, calendar } = data;
                // Add paper to unassigned list
                this.props.addPaperToUnassigned(paper);
                // Update session
                this.props.updateSession(paper.session_id, session);
                /* Calendar duration might has changed, let's update the calendar information */
                if (calendar)
                    this.props.updateCalendarSession(calendar.id, calendar);
            })
            .catch((error) => {
                alert(error);
            });
    }

    handleLiftUpClick() {
        const { paper } = this.props;
        fetch(API_URL + "/paper-sessions/papers/" + paper.id + "/liftUp", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + this.props.user.api_token,
                Accept: "application/json",
            },
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText); // Will go to .catch
                return response.json();
            })
            .then((data) => {
                /* If paper has been moved up correctly then display it by invoking parent's method that allows
            to lift up the paper from the frontend side */
                this.props.updateSession(paper.session_id, data);
            })
            .catch((error) => {
                alert(error);
            });
    }

    handleLiftDownClick() {
        const { paper } = this.props;
        fetch(API_URL + "/paper-sessions/papers/" + paper.id + "/liftDown", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + this.props.user.api_token,
                Accept: "application/json",
            },
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText); // Will go to .catch
                return response.json();
            })
            .then((data) => {
                /* If paper has been moved up correctly then display it by invoking parent's method that allows
            to lift up the paper from the frontend side */
                this.props.updateSession(paper.session_id, data);
            })
            .catch((error) => {
                alert(error);
            });
    }

    handleDragStart(event) {
        event.dataTransfer.setData("text", this.props.paper.id);
    }

    render() {
        const { paper } = this.props;

        /* Author names */
        let authorNames = "";
        for (let author of paper.authors)
            authorNames += author.full_name + ", ";
        authorNames = authorNames.substring(0, authorNames.length - 2);

        /* Keyword labels */
        const keywordList = paper.keywords.map((keyword) => (
            <Keyword
                key={keyword.id}
                keyword={keyword}
                bsStyle="label-primary"
            />
        ));

        /* Session icons (arrows and remove) */
        let icons;
        const isInDetailModal = this.props.isInDetailModal
            ? this.props.isInDetailModal
            : false;
        if (this.props.isInSession && !isInDetailModal) {
            icons = (
                <span className="pull-right">
                    <span
                        className="glyphicon glyphicon-remove-circle pointer"
                        aria-hidden="true"
                        onClick={this.handleRemovePaperClick}
                    ></span>
                    <span
                        className="glyphicon glyphicon-arrow-up pointer"
                        aria-hidden="true"
                        onClick={this.handleLiftUpClick}
                    ></span>
                    <span
                        className="glyphicon glyphicon-arrow-down pointer"
                        aria-hidden="true"
                        onClick={this.handleLiftDownClick}
                    ></span>
                </span>
            );
        }

        /* Setting a particular style when component is used in a certain context*/
        let paperNameStyle;
        let paperIdStyle;
        let keywordAttributes;
        if (isInDetailModal) {
            paperNameStyle = { fontSize: "14px" };
            paperIdStyle = { fontSize: "14px" };
            keywordAttributes = { style: { paddingTop: "10px" } };
        } else {
            keywordAttributes = { className: "keyword-display" };
        }

        const attributes = {};
        if (this.props.isInSession) {
            attributes.className = "panel";
        } else {
            attributes.className = "panel dragthis";
            attributes.draggable = "true";
            attributes.onDragStart = this.handleDragStart;
        }

        return (
            <div {...attributes}>
                <div id={paper.id} className="panel-body paper">
                    <div className="paperid" style={paperIdStyle}>
                        <span
                            className="glyphicon glyphicon-list-alt"
                            aria-hidden="true"
                        ></span>{" "}
                        {paper.external_id}{" "}
                        {!isInDetailModal && (
                            <span className="track">{paper.track.name}</span>
                        )}{" "}
                        {icons}
                    </div>
                    {isInDetailModal && (
                        <div className="papertrack">{paper.track.name}</div>
                    )}

                    <div className="papername" style={paperNameStyle}>
                        {paper.title}
                    </div>
                    <div className="authors">
                        <span
                            className="glyphicon glyphicon-user"
                            aria-hidden="true"
                        ></span>{" "}
                        {authorNames}
                    </div>
                    <div {...keywordAttributes}>{keywordList}</div>
                    <div>{this.getDurationBadge(paper.duration)}</div>
                </div>
            </div>
        );
    }
}

export default connect(null, {
    addPaperToUnassigned,
    updateSession,
    updateCalendarSession,
})(Paper);
